module.exports = __webpack_public_path__ + "search.svg?e50f398593095f5b3b143182e6307410";